import React, { useMemo } from 'react';
import { useQuery } from 'react-query';

import styled from 'styled-components';

import { getAICompetitiveIntelligence } from 'apis/RecommendationsAPI';
import LoaderRibbed from 'components/lib/LoaderRibbed';
import { useAppSelector } from 'store/hook';

import CompetitiveIntelligenceOverview from './CompetitiveIntelligenceOverview';
import RecommendationsNotFound from './RecommendationsNotFound';
import WebsiteVerificationFailures from './WebsiteVerificationFailures';

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 200px;
`;

const CommunityAiCompetitiveIntelligence = () => {
  const { selectedCommunity } = useAppSelector((state) => state.global);

  const { data, isLoading } = useQuery({
    queryKey: ['ai-competitive-intelligence', selectedCommunity?.id],
    queryFn: () => getAICompetitiveIntelligence(selectedCommunity?.id ?? -1),
    enabled: Boolean(selectedCommunity?.id),
    refetchOnWindowFocus: false,
  });

  const isEmpty = useMemo(
    () =>
      !data ||
      (data.ranking == null &&
        data.summary == null &&
        data.overall_score == null &&
        !data.strengths?.length &&
        !data.limitations?.length &&
        !data.related_data?.some((category) => category.recommendation_overview_id != null)),
    [data]
  );
  return (
    <>
      <WebsiteVerificationFailures key={selectedCommunity?.id} />
      {isLoading && (
        <LoaderContainer>
          <LoaderRibbed active />
        </LoaderContainer>
      )}
      {!isLoading && isEmpty && <RecommendationsNotFound />}
      {!isLoading && !isEmpty && <CompetitiveIntelligenceOverview data={data} />}
    </>
  );
};

export default CommunityAiCompetitiveIntelligence;
